import React from "react";
import styles from "./styles.module.scss";
import { ArrowRightIcon } from "../Icons";

interface PublicoV2Props {
  signupLink: string;
}

type Card = {
  img: string;
  titulo: string;
  desc: string;
};

const CARDS: Card[] = [
  {
    img: "/images-capa2/publico/influenciadores.png",
    titulo: "Influenciadores",
    desc: "Influenciadores digitais que desejam monetizar mais na internet podem contar com o ecossistema do Parceiros Promo. Quanto mais divulgação e vendas, mais lucro na sua conta!",
  },
  {
    img: "/images-capa2/publico/blogueiros.png",
    titulo: "Blogueiros",
    desc: "Quer ganhar mais dinheiro com seu blog? Divulgue nossas campanhas nesse canal e adquira comissionamento a cada venda convertida!",
  },
  {
    img: "/images-capa2/publico/agentes.png",
    titulo: "Agentes de Viagem",
    desc: "Já é um profissional do turismo? Divulgue nossos produtos e serviços para seus clientes e aumente ainda mais sua renda nesse nicho!",
  },
  {
    img: "/images-capa2/publico/marketing.png",
    titulo: "Profissionais de Marketing Digital",
    desc: "Aproveite sua expertise em Marketing Digital para trazer tráfego qualificado e conversão para nossas marcas. Ganhe comissão em cada venda feita em seu link!",
  },
];

const PublicoV2: React.FC<PublicoV2Props> = ({ signupLink }) => {
  return (
    <section className={styles.publico}>
      <h2>Para quem o programa é indicado?</h2>

      <div className={styles.grid}>
        {CARDS.map((c) => (
          <article key={c.titulo} className={styles.card}>
            <div
              className={styles.cardImg}
              style={{ backgroundImage: `url(${c.img})` }}
            />
            <h3>{c.titulo}</h3>
            <p>{c.desc}</p>
          </article>
        ))}
      </div>

      <div
        className={styles.cta}
        style={{
          backgroundImage:
            "radial-gradient(120% 130% at 88% -10%, rgba(255, 120, 170, 0.28), transparent 55%), radial-gradient(120% 130% at -8% 115%, rgba(255, 255, 255, 0.18), transparent 55%), url(/images-capa2/hero/noise-bg.svg)",
          backgroundSize: "auto, auto, cover",
        }}
      >
        <h2>O Parceiros Promo é para mim?</h2>
        <p>
          Está na dúvida se nossa comunidade é para você? Inicie uma conversa
          sem compromisso com nossos atendentes, indicando seu nível de
          experiência no mercado de afiliados:
        </p>
        <div className={styles.ctaButtons}>
          <a
            href="https://wa.me/553139727089?text=Olá,%20sou%20iniciante%20e%20gostaria%20de%20mais%20informações"
            className={styles.ctaButton}
            title="Sou iniciante"
            target="_blank"
            rel="noreferrer"
          >
            <span>Sou iniciante</span>
            <ArrowRightIcon color="#644ED0" />
          </a>
          <a
            href="https://wa.me/553139727089?text=Olá,%20sou%20experiente%20e%20gostaria%20de%20mais%20informações"
            className={styles.ctaButton}
            title="Tenho experiência"
            target="_blank"
            rel="noreferrer"
          >
            <span>Tenho experiência</span>
            <ArrowRightIcon color="#644ED0" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default PublicoV2;
